import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {isStringNullOrEmpty} from "../../utils";
import {IMPORT_FILE_MODE_IMPORTMODE} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import {updateWebFavor, updateWebHistory} from "../../../model";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";

const DialogWebBrowseAddBookmark = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [webInfo,setWebInfo] = useState<any>(null);

    const txtNameRef = useRef(null);
    const mCallback = useRef(null);

    useEffect(() => {
        document.body.addEventListener('keydown',onKeydown);

        return ()=>{
            document.body.removeEventListener('keydown',onKeydown);
        }
    });

    function onKeydown(event){
        if (event.key == KEYS.ENTER){
            onSave();
        }
    }

    const onShowDialog = (data,callback)=>{
        setIsShowDialog(true);
        setWebInfo(data || {});
        mCallback.current = callback;
        setTimeout(()=>{
            if (txtNameRef.current){
                // txtNameRef.current.value = data?.title;
                txtNameRef.current?.focus();
            }
        },100)
    }

    const onSave = ()=>{
        if (props.onCloseCallback) {
            props.onCloseCallback();
        }
        //保存
        webInfo.isFavor = 1;
        webInfo.favirateTime = Date.now();
        updateWebHistory(webInfo).then(res=>{
            if (mCallback.current){
                mCallback.current();
            }
        });
    }

    return <Modal width={520} zIndex={2005} className={'no-drag'} bodyStyle={{}}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t(webInfo?.isFavor == 1?'Edit bookmark':'Add bookmark')}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <span className={'mt-12'}>{t("Title")}</span>
            <input ref={txtNameRef} className={'input-border mt-10'} placeholder={t('Enter title')} value={webInfo?.title || ''} onInput={(e)=>{
                const newLink = {...webInfo};
                newLink.title = e.currentTarget.value;
                setWebInfo(newLink);
            }}/>

            <span className={'mt-18'}>{t("Link")}</span>
            <input className={'input-border mt-10'} placeholder={'https://'} value={webInfo?.url}
                   onInput={(e)=>{
                       const newLink = {...webInfo};
                       newLink.url = e.currentTarget.value;
                       setWebInfo(newLink);
                   }}/>


            <div className={'flex-center mt-32 mb-4'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                        if (webInfo?.isFavor == 1) {
                            webInfo.isFavor = 0;
                            updateWebHistory(webInfo).then(res=>{
                                if (mCallback.current){
                                    mCallback.current();
                                }
                            });
                        }
                    }}>{t(webInfo?.isFavor == 1?"Remove":"Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        onSave();
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Save")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogWebBrowseAddBookmark;